import { render, staticRenderFns } from "./MatterItem.vue?vue&type=template&id=422d6f42&scoped=true"
import script from "./MatterItem.vue?vue&type=script&lang=js"
export * from "./MatterItem.vue?vue&type=script&lang=js"
import style0 from "./MatterItem.vue?vue&type=style&index=0&id=422d6f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422d6f42",
  null
  
)

export default component.exports